export const URL_COUNTRY = "/api/v1/country";
export const URL_TOUR = "/api/v1/tour";
export const URL_CANCELLATION_REASONS = "/api/v2/cancellation/reasons";
export const URL_BOOKING_CANCELLATIONS = "/api/v2/cancellation/booking";
export const URL_DRIVER_COMMENTS = "/api/v2/comments/driver";
